import React from 'react'
import { Link } from 'react-router-dom'
import { LoginLink, LogoutLink, Authenticated, NotAuthenticated } from '../components'
import pings from '../http/pings'
import notifs from '../http/notifs'
import '../header.css'

export default function Header(props) {
  const [unreadCount, setUnreadCount] = React.useState(0)

  const updateUnreadCount = React.useCallback(() => {
    notifs.unreadCount((count) => {
      setUnreadCount(count)
    })
  }, [])

  React.useEffect(() => {
    // checkpoints (pings) infos
    pings.get('notifs', (previousVisit) => {
      localStorage.setItem('pingNotifs', previousVisit)
    })

    updateUnreadCount()
  }, [updateUnreadCount])

  // Update unread count when location changes
  React.useEffect(() => {
    updateUnreadCount()
  }, [props.location, updateUnreadCount])

  const username = localStorage.getItem('username')

  return (
    <nav className="navbar navbar-default navbar-static-top">
      <div className="container">
        <div id="navbar-collapse" className="navbar-collapse">
          <ul className="nav navbar-nav">
            <li className="logo-container">
              <Link to="/"><span className="logo" /></Link>
            </li>
            <Authenticated>
              <li className={props.location.pathname === '/search' ? 'active' : ''}>
                <Link to="/search" className="header-icon-container"><span className="header-icon icon-search" /></Link>
              </li>
            </Authenticated>
            <Authenticated>
              <li className={props.location.pathname === '/favorites' ? 'active' : ''}>
                <Link to="/favorites" className="header-icon-container"><span className="header-icon icon-star" /></Link>
              </li>
            </Authenticated>
            <Authenticated>
              <li className={props.location.pathname === '/preferences' ? 'active' : ''}>
                <Link to="/preferences" className="header-icon-container"><span className="header-icon icon-params" /></Link>
              </li>
            </Authenticated>
            <Authenticated>
              <li className={props.location.pathname === '/notifs' ? 'active' : ''}>
                <Link to="/notifs" className="header-icon-container"><span className={unreadCount === 0 ? 'header-icon icon-bell' : 'header-icon icon-bell blink'} /></Link>
              </li>
            </Authenticated>
          </ul>
          <ul className="nav navbar-nav navbar-right">
            <NotAuthenticated>
              <li>
                <LoginLink />
              </li>
            </NotAuthenticated>
            <Authenticated>
              <li className={props.location.pathname === '/profile' ? 'active' : ''}>
                <Link to="/profile">{username}</Link>
              </li>
            </Authenticated>
            <Authenticated>
              <li>
                <LogoutLink />
              </li>
            </Authenticated>
          </ul>
        </div>
      </div>
    </nav>
  )
}
